import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { getFAQ } from "./support-api";
import { SET_FAQ } from "./support-mutations";
export const LOAD_CLIENT_FAQ = "LOAD_CLIENT_FAQ";
const actions = {
  [LOAD_CLIENT_FAQ]: async context => {
    const {
      faq
    } = await getFAQ();
    const filteredFAQ = _filterInstanceProperty(faq).call(faq, question => {
      var _context;
      return _includesInstanceProperty(_context = question.accountType).call(_context, "client");
    });
    context.commit(SET_FAQ, filteredFAQ);
  }
};
export default actions;